import React from 'react';
import { Provider } from 'react-redux';
import store from '../../../../state';
import UserDutyTransactionsWidget from './index';

const StandaloneWidget = props => (
  <Provider store={store}>
    <UserDutyTransactionsWidget {...props} />
  </Provider>
);

export default StandaloneWidget;
